export default __webpack_public_path__ + "static/media/benefit_10@2x.c8cf5d99.png";